import React from "react"
import PropTypes from "prop-types"

function Instagram({ color, width, height, ...props }) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 30 30"
    >
      <path
        className="fill-current"
        fill={color}
        d="M22.7 20.8c.088-.238.163-.538.225-.913.063-.375.1-.812.137-1.325.025-.512.05-.937.05-1.262v-1.375-1-.975-1.35c0-.325-.012-.75-.05-1.262a14.567 14.567 0 00-.137-1.325A5.106 5.106 0 0022.7 9.1c-.35-.912-.988-1.55-1.912-1.912a5.106 5.106 0 00-.913-.225c-.375-.063-.813-.1-1.325-.138-.512-.025-.938-.05-1.238-.05h-4.724c-.325 0-.75.012-1.263.05-.525.025-.962.063-1.337.125a4.939 4.939 0 00-.9.225c-.925.35-1.563.987-1.913 1.913a4.939 4.939 0 00-.225.9c-.063.375-.1.812-.138 1.325-.025.524-.037.937-.037 1.25v4.262c0 .275.012.637.025 1.088.013.437.038.825.063 1.137A8.7 8.7 0 007 20c.063.325.112.587.175.8.388.912 1.025 1.55 1.913 1.912.237.088.537.163.912.226.375.062.813.1 1.325.137.513.025.938.05 1.238.05h4.724c.326 0 .75-.012 1.263-.05.512-.037.962-.075 1.325-.137.375-.063.675-.138.913-.226.924-.4 1.562-1.024 1.912-1.912zm2.137-9.938c.026.8.05 2.163.05 4.088 0 1.925-.012 3.288-.05 4.088-.087 1.8-.625 3.2-1.625 4.187-.987.987-2.387 1.512-4.187 1.575-.8.063-2.162.087-4.087.087-1.926 0-3.288-.024-4.088-.087-1.8-.088-3.2-.625-4.175-1.6a4.32 4.32 0 01-.938-1.238 5.99 5.99 0 01-.512-1.375c-.1-.437-.15-.962-.15-1.55-.05-.812-.075-2.174-.075-4.1 0-1.925.025-3.3.088-4.124.087-1.776.625-3.15 1.6-4.126.974-1 2.362-1.55 4.175-1.637.787-.037 2.15-.05 4.075-.05 1.925 0 3.287.013 4.087.05 1.8.088 3.2.625 4.188 1.625.987.975 1.524 2.375 1.624 4.188zm-3.774-2.05c.237.213.35.476.35.8 0 .325-.113.613-.338.838-.225.238-.5.35-.825.35-.325 0-.613-.113-.837-.35a1.133 1.133 0 01-.35-.837c0-.325.112-.6.35-.825.237-.226.512-.338.837-.338.337.013.6.125.813.363zm-8.475 8.476a3.21 3.21 0 002.35.974c.912 0 1.7-.325 2.35-.974a3.21 3.21 0 00.974-2.35c0-.913-.325-1.7-.974-2.35a3.21 3.21 0 00-2.35-.975c-.913 0-1.7.325-2.35.975a3.21 3.21 0 00-.975 2.35c0 .912.325 1.7.975 2.35zM11.3 11.35c1-1 2.212-1.512 3.637-1.512 1.426 0 2.626.5 3.613 1.487.988.988 1.488 2.2 1.488 3.613 0 1.425-.5 2.624-1.488 3.612s-2.2 1.488-3.613 1.488c-1.425 0-2.624-.5-3.612-1.488-.987-.988-1.487-2.2-1.487-3.613 0-1.425.487-2.612 1.462-3.587z"
      ></path>
    </svg >
  );
}

Instagram.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Instagram.defaultProps = {
  color: "#0E1A50",
  width: 30,
  height: 30,
}

export default Instagram;
